export default "__VITE_ASSET__CPTRpX8B__"